import { render, staticRenderFns } from "./TaskBody.vue?vue&type=template&id=597bcc96"
import script from "./TaskBody.vue?vue&type=script&lang=js"
export * from "./TaskBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports